<template>
<mainTemplateVue>
    <div>
        <md-toolbar :md-elevation="0" class="md-transparent">
            <h3 class="md-title">Serviços</h3>
            <md-button class="md-primary" to="/servico/novo">Adicionar novo serviço</md-button>
        </md-toolbar>

        <md-table v-model="searched" md-fixed-header>
            <md-table-empty-state
                md-label="Sem registros"
                :md-description="`No user found for this '${search}' query. Try a different search term or create a new user.`">
                <md-button class="md-primary md-raised" @click="newUser">Create New User</md-button>
            </md-table-empty-state>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID" md-sort-by="servico_id" md-numeric>{{ item.servico_id }}</md-table-cell>
                <md-table-cell md-label="Nome" md-sort-by="servico_nome">{{ item.servico_nome }}</md-table-cell>
                <md-table-cell md-label="Código" md-sort-by="servico_codigo" md-numeric>{{ item.servico_codigo }}</md-table-cell>
                <md-table-cell>
                  <md-button class="md-primary" :to="`/servico/editar/${item.servico_id}`"><md-icon>edit</md-icon></md-button>
                  <md-button class="md-accent" @click="removeItem(item.servico_id)"><md-icon>clear</md-icon></md-button>
                </md-table-cell>
            </md-table-row>
        </md-table>

        <md-snackbar :md-active.sync="showSnackMessage">{{snackMessage}}</md-snackbar>

        <md-dialog-confirm
        :md-active.sync="removeItemDialog"
        md-title="Deseja realmente remover este item?"
        md-confirm-text="Remover"
        md-cancel-text="Cancelar"
        @md-cancel="onCancelDialogRemoveItem"
        @md-confirm="onConfirmDialogRemoveItem" />
    </div>
</mainTemplateVue>
</template>

<script>
import mainTemplateVue from '../../components/main-template.vue'
import { api } from '../../services/api'

export default {
    name: 'servico-list',
    components: {
        mainTemplateVue
    },
    data: () => ({
      removeItemDialog: false,
      idToBeRemoved: null,
      snackMessage: false,
      showSnackMessage: false,
      search: null,
      searched: [],
      unidades: []
    }),
    methods: {
      newUser () {
        window.alert('Noop')
      },

      async getListItem(){
        let req = await api().get('servico')
        this.searched = req.data.data

        console.log(this.searched)
      },
      
      removeItem(id){
        this.removeItemDialog = true
        this.idToBeRemoved = id
      },

      async onConfirmDialogRemoveItem(){
        api().delete(`/servico/${this.idToBeRemoved}`).then(() =>  {
          this.showSnackMessage = true
          this.snackMessage = "Registro removido com sucesso"
          this.getListItem()
        }).catch(() => {
          this.showSnackMessage = true
          this.snackMessage = "Falha ao remover o item, verifique se há itens vinculados a ele e tente novamente."
        })
      },

      onCancelDialogRemoveItem(){
        this.idToBeRemoved = null
        this.removeItemDialog = false
      }
    },
    created () {
      this.getListItem()
    }
}
</script>

<style>
.md-table-head, .md-table-head.md-numeric {
    text-align: left !important;
}

.md-table-cell {
    text-align: left !important;
}
</style>